import {EntityFollowedEvent} from './EntityFollowedEvent';

export class TeamFollowed extends EntityFollowedEvent {}
